import React, { createContext, useContext } from 'react';
import { Link as LinkComponent } from '@pushpay/link';
import { useConstant } from '@pushpay/utils';
const LinkProviderContext = /*#__PURE__*/createContext({
  Link: LinkComponent
});
/**
 * The LinkProvider allows Link components within @pushpay/shell to be overidden.
 *
 * The main use case is to support using @pushpay/shell within ChMS which currently has a react-router@3 dependency.
 *
 * By wrapping the Shell with a <LinkProvider /> and passing @pushpay/link-old LinkOld Shell links will render with react-router@3.
 */

export function LinkProvider({
  Link,
  children
}) {
  const contextValue = useConstant(() => ({
    Link
  }));
  return /*#__PURE__*/React.createElement(LinkProviderContext.Provider, {
    value: contextValue
  }, children);
}
export function useLink() {
  return useContext(LinkProviderContext);
}